import styled from 'styled-components/macro';
import { DS_COLORS } from 'styles';

const BG_COLOR = DS_COLORS.white;
const BORDER_COLOR = DS_COLORS.gray[100];

export const Wrapper = styled.div<{ isOpen: boolean }>`
  background-color: ${BG_COLOR};
  border: 1px solid ${BORDER_COLOR};
  border-radius: 12px;
  transition-duration: 250ms;
`;

export const Trigger = styled.div`
  // Отрицательный margin компенсирует пространство,
  // создаваемое рамкой (border) у Wrapper, чтобы выровнять элементы по краям,
  // устраняя лишние зазоры.
  margin: -1px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 8px;
  border: 1px solid ${BORDER_COLOR};
  border-radius: 12px;
  cursor: pointer;
`;

export const ContentWrapper = styled.div`
  transition: 250ms;
  overflow: hidden;
`;

export const Content = styled.div`
  padding: 12px;
  border-radius: 12px;
`;
